import { render, staticRenderFns } from "./SupporterCard.vue?vue&type=template&id=6ccea2ef"
import script from "./SupporterCard.vue?vue&type=script&lang=js"
export * from "./SupporterCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports